export default __webpack_public_path__ + "static/transportation-accomplishment-1c-91b2fb01e758d3b420cf79585c8f6f6f.webp";